$(document).on('turbolinks:load', function () {

  function updateUserMedia() {
    navigator.getUserMedia = navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
  }

  function showCameraPermissionInstructions(errorName) {
    var message = "❌ Izin kamera ditolak atau diblokir.\n\n";
    message += "📱 Cara mengaktifkan izin kamera:\n\n";
    
    if (navigator.userAgent.indexOf("Chrome") > -1) {
      message += "Chrome/Edge:\n";
      message += "1. Klik ikon kunci 🔒 atau info ⓘ di sebelah kiri alamat URL\n";
      message += "2. Klik 'Setelan situs' atau 'Site settings'\n";
      message += "3. Ubah izin Kamera menjadi 'Izinkan' atau 'Allow'\n";
      message += "4. Refresh ulang halaman ini\n";
    } else if (navigator.userAgent.indexOf("Firefox") > -1) {
      message += "Firefox:\n";
      message += "1. Klik ikon kunci 🔒 di sebelah kiri alamat URL\n";
      message += "2. Klik tanda '>' di samping 'Connection Secure'\n";
      message += "3. Klik 'More Information'\n";
      message += "4. Pilih tab 'Permissions'\n";
      message += "5. Hilangkan centang 'Use default' pada Camera\n";
      message += "6. Ubah menjadi 'Allow'\n";
      message += "7. Refresh ulang halaman ini\n";
    } else if (navigator.userAgent.indexOf("Safari") > -1) {
      message += "Safari:\n";
      message += "1. Buka Safari > Preferences\n";
      message += "2. Pilih tab 'Websites'\n";
      message += "3. Pilih 'Camera' di sidebar kiri\n";
      message += "4. Ubah izin untuk situs ini menjadi 'Allow'\n";
      message += "5. Refresh ulang halaman ini\n";
    } else {
      message += "1. Klik ikon kunci/info di address bar\n";
      message += "2. Cari pengaturan izin kamera\n";
      message += "3. Ubah menjadi 'Izinkan' atau 'Allow'\n";
      message += "4. Refresh ulang halaman ini\n";
    }
    
    message += "\n⚠️ Setelah mengubah pengaturan, klik tombol ini lagi.";
    alert(message);
  }

  function showLocationPermissionInstructions() {
    var message = "❌ Izin lokasi/GPS ditolak atau diblokir.\n\n";
    message += "📍 Cara mengaktifkan izin lokasi:\n\n";
    
    if (navigator.userAgent.indexOf("Chrome") > -1) {
      message += "Chrome/Edge:\n";
      message += "1. Klik ikon kunci 🔒 atau info ⓘ di sebelah kiri alamat URL\n";
      message += "2. Klik 'Setelan situs' atau 'Site settings'\n";
      message += "3. Ubah izin Lokasi menjadi 'Izinkan' atau 'Allow'\n";
      message += "4. Refresh ulang halaman ini\n";
    } else if (navigator.userAgent.indexOf("Firefox") > -1) {
      message += "Firefox:\n";
      message += "1. Klik ikon kunci 🔒 di sebelah kiri alamat URL\n";
      message += "2. Klik tanda '>' di samping 'Connection Secure'\n";
      message += "3. Klik 'More Information'\n";
      message += "4. Pilih tab 'Permissions'\n";
      message += "5. Hilangkan centang 'Use default' pada Location\n";
      message += "6. Ubah menjadi 'Allow'\n";
      message += "7. Refresh ulang halaman ini\n";
    } else if (navigator.userAgent.indexOf("Safari") > -1) {
      message += "Safari:\n";
      message += "1. Buka Safari > Preferences\n";
      message += "2. Pilih tab 'Websites'\n";
      message += "3. Pilih 'Location' di sidebar kiri\n";
      message += "4. Ubah izin untuk situs ini menjadi 'Allow'\n";
      message += "5. Refresh ulang halaman ini\n";
    } else {
      message += "1. Klik ikon kunci/info di address bar\n";
      message += "2. Cari pengaturan izin lokasi\n";
      message += "3. Ubah menjadi 'Izinkan' atau 'Allow'\n";
      message += "4. Refresh ulang halaman ini\n";
    }
    
    message += "\n⚠️ Setelah mengubah pengaturan, klik tombol ini lagi.";
    alert(message);
  }

  function requestCameraPermission() {
    updateUserMedia();
    
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      alert("❌ Browser Anda tidak mendukung akses kamera.\n\nSilakan gunakan browser modern seperti Chrome, Firefox, Safari, atau Edge.");
      return;
    }

    // Check permission status first if Permissions API is available
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'camera' })
        .then(function(permissionStatus) {
          if (permissionStatus.state === 'denied') {
            showCameraPermissionInstructions();
            return;
          }
          // If not denied, try to request
          attemptCameraAccess();
        })
        .catch(function() {
          // Permissions API not fully supported, try direct access
          attemptCameraAccess();
        });
    } else {
      // Permissions API not available, try direct access
      attemptCameraAccess();
    }
  }

  function attemptCameraAccess() {
    navigator.mediaDevices
      .getUserMedia({video: true, audio: false})
      .then(function (stream) {
        alert("✅ Izin kamera berhasil diberikan!");
        // Stop the camera immediately after getting permission
        var tracks = stream.getTracks();
        tracks.forEach(function(track) {
          track.stop();
        });
      })
      .catch(function (error) {
        console.error("Camera error:", error);
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          showCameraPermissionInstructions(error.name);
        } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
          alert("❌ Kamera tidak ditemukan.\n\nPastikan perangkat Anda memiliki kamera dan tidak sedang digunakan aplikasi lain.");
        } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
          alert("❌ Kamera tidak dapat diakses.\n\nKamera mungkin sedang digunakan aplikasi lain. Tutup aplikasi lain yang menggunakan kamera dan coba lagi.");
        } else {
          showCameraPermissionInstructions(error.name);
        }
      });
  }

  function requestLocationPermission() {
    if (!navigator.geolocation) {
      alert("❌ Browser Anda tidak mendukung Geolocation.\n\nSilakan gunakan browser modern seperti Chrome, Firefox, Safari, atau Edge.");
      return;
    }

    // Check permission status first if Permissions API is available
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' })
        .then(function(permissionStatus) {
          if (permissionStatus.state === 'denied') {
            showLocationPermissionInstructions();
            return;
          }
          // If not denied, try to request
          attemptLocationAccess();
        })
        .catch(function() {
          // Permissions API not fully supported, try direct access
          attemptLocationAccess();
        });
    } else {
      // Permissions API not available, try direct access
      attemptLocationAccess();
    }
  }

  function attemptLocationAccess() {
    navigator.geolocation.getCurrentPosition(
      function(position) {
        alert("✅ Izin GPS berhasil diberikan!\n\n📍 Lokasi Anda:\nLat: " + position.coords.latitude.toFixed(6) + "\nLng: " + position.coords.longitude.toFixed(6));
      },
      function(error) {
        console.error("Location error:", error);
        switch (error.code) {
          case error.PERMISSION_DENIED:
            showLocationPermissionInstructions();
            break;
          case error.POSITION_UNAVAILABLE:
            alert("❌ Informasi GPS tidak tersedia.\n\nPastikan GPS/Location Services aktif di perangkat Anda.");
            break;
          case error.TIMEOUT:
            alert("⏱️ Timeout saat mencari informasi GPS.\n\nCoba lagi atau pindah ke lokasi dengan sinyal GPS lebih baik.");
            break;
          default:
            alert("❌ Error GPS tidak diketahui.\n\nSilakan coba lagi atau hubungi administrator.");
            break;
        }
      },
      { timeout: 10000, enableHighAccuracy: true, maximumAge: 0 }
    );
  }

  $("button#recalibrate_camera_button").on("click", function () {
    requestCameraPermission();
  });

  $("button#recalibrate_gps_button").on("click", function () {
    requestLocationPermission();
  });

});
